import React from 'react';
import { string, number, func } from 'prop-types';
import styles from './styles/styles.module.scss';
import Button from '../../../../../components/shared/Button';
import { StringConstantsMixin } from '../../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    COMMUNITY: {
      CONNECT: { VIEW_ALL }
    }
  }
} = StringConstantsMixin;

const ActionCardListBase = ({ header, truncateLimit, children, handleViewAllClick, className }) => {
  const needsTruncating = truncateLimit && children.length > truncateLimit;
  const shownChildren = needsTruncating ? children.slice(0, truncateLimit) : children;

  return (
    <div className={`${styles.container} ${className}`}>
      {header && <h2 className={styles.header}>{header}</h2>}
      {shownChildren}
      {needsTruncating && handleViewAllClick && (
        <Button classes={styles.viewAll} variant="flat" onClick={handleViewAllClick}>
          {VIEW_ALL} ({children.length})
        </Button>
      )}
    </div>
  );
};

ActionCardListBase.propTypes = {
  header: string,
  truncateLimit: number,
  handleViewAllClick: func,
  className: string
};

ActionCardListBase.defaultProps = {
  header: null,
  truncateLimit: null,
  handleViewAllClick: null,
  className: ''
};

export default ActionCardListBase;
